module.exports = __webpack_public_path__ + "media/3x/D-b4c2bbce.png";